'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { useEffect, useState } from 'react';
import { classNames } from '@repo/ui/src/utils/classNames';
import Slider from 'react-slick';
import { LeftArrow, RightArrow } from '../carousels';
import CarouselItem from './_CarouselItem';

const CategorySlider = ({ categories, shouldOverlap, darkMode, _testID }) => {
  const { path } = useCurrentUrl();
  const isInfinite = categories.length > 1;
  const settings = {
    infinite: isInfinite,
    arrows: true,
    slidesToShow: categories?.length > 6 ? 6 : categories?.length,
    slidesToScroll: 1,
    nextArrow: <RightArrow darkMode={darkMode} arrowSize="35px" />,
    prevArrow: <LeftArrow darkMode={darkMode} arrowSize="35px" />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: categories?.length > 4 ? 4 : categories?.length,
          infinite: isInfinite,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: categories?.length > 3 ? 3 : categories?.length,
          infinite: isInfinite,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: categories?.length > 2 ? 2 : categories?.length,
          infinite: isInfinite,
        },
      },
    ],
  };

  const [isAnySelected, setIsAnySelected] = useState(false);
  const [sortedCategories, setSortedCategories] = useState(categories);

  useEffect(() => {
    const index = categories.findIndex((x) => !!path && x?.link && path === x.link.link);
    setIsAnySelected(index >= 0);
    if (index >= 0) {
      // Put the selected category at the beginning of the carousel
      setSortedCategories([categories[index], ...categories.filter((_x, i) => i !== index)]);
    }
  }, [path, categories]);

  return (
    <section
      className={classNames(
        'category-slider tw-px-16 tw-py-16 tw-overflow-hidden',
        'xs:tw-px-0 xs:tw-py-16',
        darkMode ? 'tw-bg-neutral-800' : 'tw-bg-transparent',
        shouldOverlap && 'tw-relative tw-bg-transparent tw-z-20 tw-left-0 -tw-top-20 overlap',
        '[&_.slick-slide>div]:tw-flex-1',
        'xs:[&_.slick-slide:first-child]:tw-ml-[20vw]',
        'xs:[&_.slick-slide:last-child]:tw-mr-7',
        'xs:[&_.slick-arrow]:tw-invisible',
        '[&_.slick-arrow:focus-visible]:tw-outline-2 [&_.slick-arrow:focus-visible]:tw-outline-brand-200 [&_.slick-arrow:focus-visible]:tw-outline',
      )}
      role="region"
      aria-label="carousel"
      data-test-id={`category_slider_${_testID}`}
    >
      <Slider {...settings} className="match-height">
        {sortedCategories?.map((item, index) => (
          <CarouselItem
            key={item.category}
            {...item}
            darkMode={darkMode}
            index={index}
            isAnySelected={isAnySelected}
            role="group"
            aria-label={`Category ${index + 1} of ${sortedCategories.length}: ${item.category}`}
          />
        ))}
      </Slider>
    </section>
  );
};

export default CategorySlider;
